module.exports = __webpack_public_path__ + "img/flower-not.000f6b77.png";